import AbstractCRMApi from '../AbstractCRMApi';

import AdminsApi from './Modules/AdminsApi';

import AffiliateOwnersApi from './Modules/AffiliateOwnersApi';
import AffiliateRevenuePercentagesApi from './Modules/AffiliateRevenuePercentagesApi';
import AffiliatesApi from './Modules/AffiliatesApi';
import ArticlesApi from './Modules/ArticlesApi';
import BlockedCountriesApi from './Modules/BlockedCountriesApi';
import CasinoSlidersApi from './Modules/CasinoSlidersApi';
import CurrencyApi from './Modules/CurrencyApi';
import CustomBoxApi from './Modules/CustomBoxApi';
import DatabaseLogApi from './Modules/DatabaseLogApi';
import DepositsApi from './Modules/DepositsApi';
import FaqCategoryApi from './Modules/FaqCategoryApi';
import FaqsApi from './Modules/FaqsApi';
import GlobalsApi from './Modules/GlobalsApi';
import LanguagesApi from './Modules/LanguagesApi';
import LootboxApi from './Modules/Lootbox/LootboxApi';
import LootboxItemsApi from './Modules/Lootbox/LootboxItemsApi';
import LootboxPoolsApi from './Modules/Lootbox/LootboxPoolsApi';
import UserLootboxesApi from './Modules/Lootbox/UserLootboxesApi';
import LotteriesApi from './Modules/LotteriesApi';
import LotteryRulesApi from './Modules/LotteryRulesApi';
import ManualNotificationsApi from './Modules/ManualNotificationsApi';
import MenuItemsApi from './Modules/MenuItemsApi';
import MenusApi from './Modules/MenusApi';
import MultiDrawTicketsApi from './Modules/MultiDrawTicketsApi';
import PaymentMethodsApi from './Modules/PaymentMethodsApi';
import ResellersApi from './Modules/ResellersApi';
import ScratchcardTicketsApi from './Modules/ScratchcardTicketsApi';
import SlidersApi from './Modules/SlidersApi';
import SubAffiliatesApi from './Modules/SubAffiliatesApi';
import TicketsApi from './Modules/TicketsApi';
import UsersApi from './Modules/UsersApi';

import WithdrawalMethodsApi from './Modules/WithdrawalMethodsApi';
import WithdrawalsApi from './Modules/WithdrawalsApi';

import PageSettingsApi from 'Api/PageSettingsApi';

class CRMApi extends AbstractCRMApi {
    // It is recommended to add modules in alphabetical order
    public admins = AdminsApi;
    public affiliateOwners = AffiliateOwnersApi;
    public affiliateRevenuePercentages = AffiliateRevenuePercentagesApi;
    public affiliates = AffiliatesApi;
    public articles = ArticlesApi;
    public blockedCountries = BlockedCountriesApi;
    public casinoSliders = CasinoSlidersApi;
    public currency = CurrencyApi;
    public customBox = CustomBoxApi;
    public databaseLog = DatabaseLogApi;
    public deposits = DepositsApi;
    public faqCategories = FaqCategoryApi;
    public faqs = FaqsApi;
    public globals = GlobalsApi;
    public languages = LanguagesApi;
    public lotteries = LotteriesApi;
    public lotteryRules = LotteryRulesApi;
    public manualNotifications = ManualNotificationsApi;
    public menuItems = MenuItemsApi;
    public menus = MenusApi;
    public multiDrawTickets = MultiDrawTicketsApi;
    public pageSettings = PageSettingsApi;
    public paymentMethods = PaymentMethodsApi;
    public resellers = ResellersApi;
    public scratchcardTickets = ScratchcardTicketsApi;
    public userLootboxes = UserLootboxesApi;
    public lootboxes = LootboxApi;
    public lootboxItems = LootboxItemsApi;
    public lootboxPools = LootboxPoolsApi;
    public sliders = SlidersApi;
    public subAffiliates = SubAffiliatesApi;
    public tickets = TicketsApi;
    public users = UsersApi;
    public withdrawalMethods = WithdrawalMethodsApi;
    public withdrawals = WithdrawalsApi;
}

export default new CRMApi();
